import styled from 'styled-components'

export const HeaderItemWrapperStyled = styled.div.attrs((props) => ({
    className: 'col-xxl-1  col-xl-2  col-md-2 ',
}))`
    margin-right: 10px;
    width: auto;
    text-align: center;
`
